import FormattedPrice from "../FormattedPrice";
import classnames from "classnames";
import styles from "./index.css";
import PropTypes from "prop-types";

const CurrentPrice = ({
  priceInfo,
  hasMultiplePricesInStock,
  variantId,
  Prefix
}) => {
  const { currentPrice, isDiscounted } = priceInfo;

  return (
    <span
      className={classnames(styles.currentPrice, {
        [styles.discounted]: isDiscounted
      })}
    >
      <Prefix
        priceInfo={priceInfo}
        hasMultiplePricesInStock={hasMultiplePricesInStock}
        variantId={variantId}
      />
      <FormattedPrice value={currentPrice} />
    </span>
  );
};

CurrentPrice.propTypes = {
  priceInfo: PropTypes.shape({
    currentPrice: PropTypes.number,
    isDiscounted: PropTypes.bool
  }).isRequired,
  hasMultiplePricesInStock: PropTypes.bool.isRequired,
  variantId: PropTypes.number,
  Prefix: PropTypes.elementType.isRequired
};

export default CurrentPrice;
